var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55776 0.192209C8.81405 0.448488 8.81405 0.864008 8.55776 1.12029L4.83904 4.83901C4.58276 5.0953 4.16724 5.0953 3.91096 4.83901L0.192209 1.12029C-0.0640697 0.864008 -0.0640697 0.448488 0.192209 0.192209C0.448488 -0.0640697 0.864008 -0.0640697 1.12029 0.192209L4.375 3.44692L7.62974 0.192209C7.88602 -0.0640697 8.30147 -0.0640697 8.55776 0.192209Z",
    fill: "#0C143C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownArrow);
export default __webpack_public_path__ + "static/media/ic-down-arrow.03fc9acacdccf0739ac31a6b0c90d427.svg";
export { ForwardRef as ReactComponent };